import { Components, Theme } from "@mui/material/styles"

const Popover = (theme: Theme): Components => {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[2],
        },
      },
    },
  }
}

export default Popover
